import type { Messages } from '../messages.js'

/**
 * Croatian. Three plural forms, and `Intl.PluralRules` picks between them: one for 1, 21, 31,
 * few for 2 to 4, other for the rest. Writing that by hand is how it gets written wrong.
 */
export const hr: Messages = {
  tag: 'hr',

  readingDictionary: 'Čitanje rječnika…',
  noWordList: 'Nema popisa riječi za „{language}“. Izgradi ga:  pnpm dictionary build',
  emptyWordList: 'Popis riječi za „{language}“ je prazan.',

  flips: 'okreti',
  score: 'bodovi',
  words: 'riječi',
  round: 'runda',
  ticksLeftLabel: 'Preostalo vrijeme u rundi',
  typeAWord: 'upiši riječ',
  tapPrompt: 'dotaknite da uzmete ili vratite, zatim {action}',

  boardOfTiles: 'Ploča od {n} pločica',
  faceDown: 'okrenuta',
  wildCard: 'džoker',
  wildKey: 'bilo koje slovo',
  letterReplaced: '{from} je postalo {to}',
  letterSwap: 'ZAMJENA SLOVA!',
  spentTile: 'potrošena pločica',
  hiddenWhilePaused: 'skrivena tijekom pauze',
  letterInWord: '{letter}, {position}. slovo riječi',

  completeWord: 'Potvrdi riječ',
  completeShort: 'Potvrdi',
  reset: 'Očisti',
  pause: 'Pauza',
  resume: 'Nastavi',
  newGame: 'Nova igra',
  paused: 'Pauzirano',
  outOfFlips: 'Nema više okreta',
  finalResult: '{score} bodova, {words} u {rounds}',
  playAgain: 'Igraj ponovno',
  share: 'Podijeli',
  shareCopied: 'Kopirano.',
  shareSelect: 'Kopirajte ovo:',

  lettersSelect: 'slova označavaju',
  keysWild: 'uzima se kad upišete slovo koje nijedna pločica ne pokazuje',
  clearsEvery: 'briše sva označena {letter}',
  undoLastLetter: 'briše zadnje slovo',
  noWordsYet: 'Još nema riječi.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'već nađena',
  reasonTooShort: 'previše kratka',
  reasonNotAWord: 'nije riječ',
  reasonAllFound: 'sve ih već imate',
  noSuchLetterUp: 'nema otkrivenog {letter}',
  nothingUp: 'ništa otkriveno',
  letterHidden: 'jedno se slovo skrilo',
  shuffled: 'promiješano',
  shuffledAndBilled: 'promiješano, naplaćeno {flips} neiskorištenih okreta',
  tooFewLetters: 'Ostalo je premalo slova',

  gameLanguage: 'jezik',
  interfaceLanguage: 'sučelje',
  dictionarySize: '{common} čestih od {full} riječi',
  filterLanguages: 'Pretraži jezike',
  noMatches: 'Nema rezultata',

  nerdMode: 'stručni prikaz',
  rules: 'Pravila',
  difficulty: 'težina',
  difficultyNames: { easy: 'lako', medium: 'srednje', hard: 'teško', insane: 'brutalno' },
  pausedNoBoard: 'Ova igra neće doći na ljestvicu.',
  about: 'O igri',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradicionalna', light: 'svijetla', contrast: 'visoki kontrast' },
  tiles: 'pločice (N)',
  secondsPerTick: 'sekundi / takt',
  holdTicks: 'taktovi držanja',
  minWord: 'najkraća riječ',
  startingFlips: 'početni okreti',
  wildChance: 'vjerojatnost džokera',
  replaceChance: 'vjerojatnost zamjene slova',
  hideChance: 'vjerojatnost skrivanja slova',
  wordCompleteMode: 'riječ dovršena',
  wordCompleteNames: { shuffle: 'promiješaj', spend: 'potroši', keep: 'zadrži' },
  flipEconomy: 'ekonomija okreta',
  flipEconomyNames: {
    none: 'nikakva',
    perLetter: 'po slovu',
    fibonacci: 'fibonacci',
    overMinimum: 'iznad minimuma',
  },
  repeatedLetterKey: 'tipka za ponovljeno slovo',
  keySchemeNames: { cycle: 'kruži', advance: 'napreduj' },
  keySchemeHelp: {
    cycle:
      'A uzima sljedeći slobodni A, a kad su svi u riječi, briše ih. ' +
      'Shift+A ih također briše.',
    advance: 'A uzima sljedeći slobodni A. Shift+A briše svaki A iz riječi.',
  },

  whatThatMeans: 'Što to znači',
  factRound: 'runda',
  factWholeBoardUp: 'cijela ploča otkrivena',
  factRoundCosts: 'runda košta',
  factFlipsBuy: 'početni okreti vrijede',
  factThisBoard: 'ova ploča',
  factBoardHadToAdmit: 'ploča je morala dopustiti',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, najduža {longest}',
  wordsIncludingOneOf: '{words}, uključujući jednu od {ceiling}',
  scorelessRounds: '{rounds} bez bodova',

  whatAWordPays: 'Što riječ donosi',
  columnLetters: 'slova',
  columnCost: 'cijena',
  columnPoints: 'bodovi',
  columnFlips: 'okreti',
  columnNet: 'neto',

  canonicalRules: 'Službena pravila za {difficulty}.',
  customRules: 'Promijenjeno od zadanog. Rezultati s vlastitim pravilima se ne rangiraju.',
  applyAndStart: 'Primijeni i započni novu igru',
  changesNextGame: 'Promjene vrijede od sljedeće igre.',
  presets: 'Postavke:',

  start: 'Počni',
  restart: 'Ponovi',
  quit: 'Izađi',
  quitTitle: 'Izaći iz ove igre?',
  restartTitle: 'Ponovno započeti ovu igru?',
  restartConfirm: 'Ponovno',
  quitConfirm: 'Izađi',
  keepPlaying: 'Nastavi igrati',
  personalBest: 'Tvoje najbolje igre',
  newPersonalBest: 'Novi osobni rekord.',
  columnRank: '#',
  notRanked: 'Vlastita pravila, pa se ova igra ne rangira.',
  notRankedPaused: 'Sat je stao, pa se ova igra ne rangira.',
  rankOfTotal: '{rank} od {total}',

  howToPlay: 'Kako se igra',

  backToGame: 'Natrag na igru',
  welcomeTitle: 'Dobro došli u Blinkered',
  tutorialSkip: 'Preskoči',
  tutorialNext: 'Dalje',
  tutorialBack: 'Natrag',
  tutorialStart: 'Počni igrati',
  tutorialHideAgain: 'Ne prikazuj više',
  tutorialProgress: '{n} od {total}',
  tutorialSkipTitle: 'Preskočiti uvod?',
  tutGoalTitle: 'Blinkered je utrka',
  tutGoalBody:
    'Igru počinjete s određenim brojem okreta, a svaka pločica koja se okrene troši jedan okret. Kad okreti nestanu, igra je gotova. Riječi donose okrete, i što je riječ duža, to više okreta dobivate.',
  tutSpentBody:
    'Slova koja upotrijebite u riječi okreću se licem prema dolje do sljedeće runde. Samo zamjena slova mijenja koja su slova na ploči.',
  tutChangeTitle: 'Slova se mogu mijenjati',
  tutSameLetters:
    'Uočili ste riječ koju niste stigli odigrati? Ista slova vraćaju se u sljedećoj rundi, promiješana na nova mjesta.',
  tutPickLetters: 'Dodirnite slova koja želite, redom, da složite riječ.',
  tutMoreTurn: 'Pločice se okreću i dok razmišljate, pa još može stići bolje slovo.',
  tutTapBack: 'Uzeli ste krivo? Dodirnite ga ponovno da ga vratite. Bilo koje, ne samo zadnje.',
  tutComplete: 'Pritisnite Gotovo kad je riječ spremna.',
  htBoardTitle: 'Ploča',
  htBoardBody:
    'Pločice se otkrivaju jedna po jedna, u slučajnom redoslijedu. Od otkrivenih pločica slažete riječi.',
  htWordsTitle: 'Riječi',
  htWordsBody: 'Složite riječ od otkrivenih pločica upisivanjem ili klikanjem slova redom.',
  htFlipsTitle: 'Okreti',
  htFlipsBody:
    'Svaka pločica koja se okrene troši jedan okret. Dovršena riječ vraća okrete na vaš zbroj, a duge riječi vraćaju više. Kad okreti nestanu, igra je gotova.',
  htRoundTitle: 'Runda',
  htRoundBody:
    'Kad se okrene zadnja pločica runde, cijela ploča ostaje otkrivena na trenutak. Zatim se pločice okrenu naopako i promiješaju, i počinje nova runda.',
  htLanguagesTitle: 'Jezici',
  htLanguagesBody:
    '{n}. Svaka se ploča može riješiti riječima koje se stvarno koriste. Neobična riječ ipak vrijedi, ako je rječnik zna.',
  htKeysTitle: 'Tipkovnica',
  htWildTitle: 'Džokeri',
  htWildBody:
    'Ponekad se umjesto slova pojavi džoker. Džoker vrijedi kao bilo koje slovo koje tvori valjanu riječ. Već dovršena riječ ne vrijedi.',
  htHideTitle: 'Slova koja se skrivaju',
  htHideBody:
    'Na težim razinama otkriveno slovo može se samo okrenuti i vratiti se kasnije u krugu. Mjerač vremena za to dobiva dodatni takt, u crvenom. Već uzeta slova ne okreću se.',
  tutHideBody:
    'Na težim razinama otkriveno slovo može se samo okrenuti i vratiti se kasnije u krugu. Već uzeta slova ne okreću se.',
  htSwapTitle: 'Slova se mijenjaju',
  htSwapBody:
    'Ponekad se između rundi jedno slovo zamijeni drugim. Vidjet ćete koje je slovo maknuto i koje je dodano.',
  htLevelsTitle: 'Razine',
  htLevelEasy:
    'Istih dvanaest slova cijelu igru, pa ih možete naučiti i držati popis riječi u glavi. Pločice se okreću polako, a puna ploča ostaje na vidiku dovoljno dugo da na miru odaberete slova.',
  htLevelMedium:
    'Slovo se povremeno promijeni, pa je teže zapamtiti riječi koje ste kanili odigrati poslije. Manje vremena za gledanje i manje za razmišljanje.',
  htLevelHard:
    'Riječi od tri slova više se ne broje, a slovo se mijenja otprilike svake druge runde. Ploča se jedva vidi prije nego što se promiješa.',
  htLevelInsane:
    'Sve odjednom i punom brzinom. Ploča se promiješa gotovo odmah nakon zadnjeg okreta.',
  htTouchTitle: 'Zaslon na dodir',
  htTouchBody:
    'Dotaknite otkrivenu ploču da uzmete njezino slovo. Dotaknite bilo koje uzeto slovo da ga vratite. Potvrdi i Očisti su ispod ploče.',

  accountTitle: 'Tvoj račun',
  menuProfile: 'Moj profil',
  menuGames: 'Moje igre',
  menuPublicPage: 'Moja javna stranica',
  menuSignedInAs: 'Prijavljen kao',
  signIn: 'Prijava',
  signOut: 'Odjava',
  signInTitle: 'Prijavi se ili otvori račun',
  signInLead: 'Račun čuva tvoje igre, na svakom uređaju.',
  signInKeepGame: 'Prijavi se da sačuvaš ovu igru, i svaku sljedeću.',
  continueWithApple: 'Nastavi s Appleom',
  continueWithGoogle: 'Nastavi s Googleom',
  signInOr: 'ili',
  emailLabel: 'E-pošta',
  codeLabel: 'Kod',
  emailMeACode: 'Pošaljite mi kod',
  working: 'Trenutak…',
  sendNewCode: 'Pošalji novi kod',
  codeSent: 'Pogledaj poštu. Kod vrijedi 10 minuta.',
  notNow: 'Ne sada',
  badEmail: 'Ovo ne izgleda kao adresa e-pošte.',
  badCode: 'Taj kod nije radio. Kodovi istječu nakon 10 minuta i vrijede jednom.',
  serverBusy: 'Poslužitelj nije dostupan. Pokušaj za trenutak.',
  serverDown: 'Poslužitelj nije dostupan.',
  offline: 'Izvan mreže',
  leaderboardTitle: 'Poredak',
  leaderboardEmpty: 'Na ovom poretku još nema igara. Budi prvi.',
  leaderboardWouldBe: 'Gdje bi ova igra stajala',
  leaderboardThisGame: 'Ova igra',
  leaderboardRanksHere: 'Gdje ova igra stoji',
  leaderboardOutside: 'Izvan prvih pet.',
  tutAccountTitle: 'Sačuvaj svoje rezultate',
  tutAccountBody:
    'Račun čuva tvoje igre, stavlja tvoje rezultate na poredak i održava tvoj profil.',
  ssoCancelled: 'Prijava otkazana.',
  ssoExpired: 'Predugo je trajalo. Prijavi se ponovno.',
  ssoNoUsername: 'Račun nije bilo moguće dovršiti. Pokušaj za trenutak.',
  ssoFailed: 'Nije uspjelo. Pokušaj ponovno ili koristi e-poštu.',
  tabProfile: 'Profil',
  countryAny: 'Radije ne bih rekao',
  findCountry: 'Traži države',
  usernameLabel: 'Korisničko ime',
  bioLabel: 'O meni',
  countryLabel: 'Država',
  bioHint: 'Bez poveznica. {left}/{max}',
  save: 'Spremi',
  saving: 'Spremam…',
  saved: 'Spremljeno.',
  nameTaken: 'To ime već netko ima.',
  nameTooShort: 'Malo duže, molim.',
  nameTooLong: 'Predugo je.',
  nameBadCharacters: 'Samo slova, brojke, crtice i podvlake.',
  nameBadEdges: 'Mora početi i završiti slovom ili brojkom.',
  nameMixedScripts: 'Odaberi jedno pismo i ostani u njemu.',
  nameReserved: 'Ovo izgleda kao ime koje dijelimo mi. Odaberi drugo.',
  nameUnusable: 'To ime se ne može koristiti.',
  bioTooLong: 'Opis ima najviše {max} znakova.',
  bioHasLink: 'Poveznice u opisu nisu dopuštene.',
  bioHasControl: 'Sadrži znakove koje opis ne može imati.',
  bioUnusable: 'Taj opis se ne može koristiti.',
  gamesHeading: 'Igre',
  gamesEmpty: 'Ovdje još nema ničega. Igre odigrane dok si prijavljen pojavit će se ovdje.',
  gamesEmptyShort: 'Ovdje još nema ničega.',
  gamesLoading: 'Čitam tvoje igre…',
  theirGamesLoading: 'Čitam njihove igre…',
  profileLoading: 'Čitam profil…',
  playerNotFound: 'Ovdje nema nikoga s tim imenom.',
  columnWhen: 'Kada',
  columnRounds: 'rundi',
  columnGame: 'Igra',
  gameLoading: 'Čitam igru…',
  gameUnreadable: 'Ovu igru nije bilo moguće pročitati.',
  gameNotRanked: 'Odigrana s izmijenjenim pravilima, pa se ne rangira.',
  detailNotKept: 'Riječi i ploče ove igre više se ne čuvaju.',
  openingBoard: 'Početna ploča',
  roundByRound: 'Rundu po rundu',
  roundNothing: 'ništa nije nađeno',
  changeReplaced: '{letter} zamijenjeno na mjestu {slot}',
  changeWildOn: '{letter} džoker na mjestu {slot}',
  changeWildOff: '{letter} džoker maknut s mjesta {slot}',
  keepThisGame: 'Sačuvaj ovu igru',
  savedToYourGames: 'Spremljeno među tvoje igre.',

  reportThis: 'Prijavi',
  reportHeading: 'Prijavi ovo',
  reportTheName: 'Ime',
  reportTheBio: 'Opis',
  reportTheScore: 'Rezultat',
  reportWhy: 'Što s tim nije u redu? Neobavezno.',
  reportSend: 'Pošalji prijavu',
  reportSent: 'Hvala. Netko će to pogledati.',
  reportSignIn: 'Za ovo moraš biti prijavljen.',
  reportGone: 'Toga više nema.',
  reportCancel: 'Odustani',

  deleteAccount: 'Izbriši moj račun',
  deleteAccountWhat:
    'Ovo zauvijek uklanja tvoj profil i svaku igru koju si zadržao. Ne može se vratiti.',
  deleteAccountAsk: 'Pošalji mi kod',
  deleteConfirm: 'Izbriši zauvijek',
  deleteGone: 'Tvoj račun je izbrisan. Hvala što si igrao.',
  deleteNoAddress:
    'Na ovom računu nema potvrđene adrese, pa se brisanje ne može provjeriti. Javi nam se i učinit ćemo to ručno.',

  rulesetFacts: 'Riječi od {letters} · {seconds} po pločici',
  plurals: {
    words: { one: '{n} riječ', few: '{n} riječi', other: '{n} riječi' },
    rounds: { one: '{n} runda', few: '{n} runde', other: '{n} rundi' },
    flips: { one: '{n} okret', few: '{n} okreta', other: '{n} okreta' },
    ticks: { one: '{n} takt', few: '{n} takta', other: '{n} taktova' },
    points: { one: '{n} bod', few: '{n} boda', other: '{n} bodova' },
    minLetters: {
      one: 'najmanje {n} slova',
      few: 'najmanje {n} slova',
      other: 'najmanje {n} slova',
    },
    seconds: { one: '{n} sekunda', few: '{n} sekunde', other: '{n} sekundi' },
  },
}
